"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var VegasSoldierTiles;
(function (VegasSoldierTiles) {
    VegasSoldierTiles["Bodyguard"] = "Bodyguard";
    VegasSoldierTiles["Guard"] = "Guard";
    VegasSoldierTiles["Marksman"] = "Marksman";
    VegasSoldierTiles["Mercenary"] = "Mercenary";
})(VegasSoldierTiles = exports.VegasSoldierTiles || (exports.VegasSoldierTiles = {}));
var VegasModuleTiles;
(function (VegasModuleTiles) {
    VegasModuleTiles["Agitator"] = "Agitator";
    VegasModuleTiles["Medic"] = "Medic";
    VegasModuleTiles["Saboteur"] = "Saboteur";
    VegasModuleTiles["Scout"] = "Scout";
})(VegasModuleTiles = exports.VegasModuleTiles || (exports.VegasModuleTiles = {}));
var VegasFoundationTiles;
(function (VegasFoundationTiles) {
    VegasFoundationTiles["Mine"] = "Mine";
})(VegasFoundationTiles = exports.VegasFoundationTiles || (exports.VegasFoundationTiles = {}));
